import { Home, Search } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 flex items-center justify-center p-6">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6">
          <div className="text-center space-y-6">
            <div className="flex justify-center">
              <div className="relative">
                <div className="text-9xl font-bold text-muted-foreground/20">
                  404
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Search className="h-16 w-16 text-muted-foreground" />
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <h1 className="text-3xl font-bold">Page Not Found</h1>
              <p className="text-muted-foreground">
                The page you're looking for doesn't exist or has been moved.
              </p>
            </div>

            <div className="flex gap-4 justify-center">
              <Button onClick={() => navigate("/")} variant="default">
                <Home className="h-4 w-4 mr-2" />
                Go Home
              </Button>
              <Button onClick={() => navigate(-1)} variant="outline">
                Go Back
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFoundPage;

